<template>
  <div class="about_container">
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ aboutPageLang.titleOne }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbarLang.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="toPath">{{ navbarLang.about }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeNameText !== ''">{{
            activeNameText
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="aboutPageLang.tabnav.about" name="1">
          <About v-if="activeName == '1'"></About>
        </el-tab-pane>
        <el-tab-pane :label="aboutPageLang.tabnav.history" name="2">
          <History v-if="activeName == '2'"></History>
        </el-tab-pane>
        <el-tab-pane :label="aboutPageLang.tabnav.network" name="3">
          <Network v-if="activeName == '3'"></Network>
        </el-tab-pane>
        <el-tab-pane :label="aboutPageLang.tabnav.ability" name="4">
          <Ability v-if="activeName == '4'"></Ability>
        </el-tab-pane>
        <el-tab-pane :label="aboutPageLang.tabnav.quality" name="5">
          <Quality v-if="activeName == '5'"></Quality>
        </el-tab-pane>
        <el-tab-pane :label="aboutPageLang.tabnav.development" name="6">
          <Development  v-if="activeName == '6'"></Development>
        </el-tab-pane>
        <el-tab-pane :label="aboutPageLang.tabnav.qualifications" name="7">
          <Qualifications v-if="activeName == '7'"></Qualifications>
        </el-tab-pane>
      </el-tabs>
    </div>
    <template v-if="activeName === '0'">
      <div class="about-wap1">
        <div class="about-content">
          <img :src="aboutPageLang.about60thImg" alt="" />
          <p v-html="$convertPxToRem(aboutPageLang.contentOne)"></p>
        </div>
      </div>
      <div class="about-wap2">
        <div class="about-content flex f-column f-center">
          <img src="../../assets/images/about/aboutlogo.png" alt="" />

          <!-- "more"跳转需要修改，点击跳转到“关于kelk" -->
          <p>
            {{ aboutPageLang.contentThree }}
          </p>

          <!-- "more"跳转需要修改，点击跳转到“关于kelk" -->
          <div class="dynamic_btn" style="margin-top:80px;" @click="toAbout">
            <span>MORE</span>
            <img
              class="more_btn"
              src="../../assets/images/public/arrow1.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="about-wap3">
        <div
          class="about-content"
          style="display: flex; justify-content: space-between"
        >
          <div class="box">
            <div class="image-container">
              <img
                src="../../assets/images1/about2.jpg"
                alt=""
                class="about-wap3__img"
              />
            </div>
            <div class="other-container">
              <div>
                <h2 class="title">{{ aboutPageLang.contentFour.history.title }}</h2>
                <p class="about-wap3__paragraph">
                  {{ aboutPageLang.contentFour.history.content }}
                </p>
              </div>
              <div class="dynamic_btn" @click="toHistory">
                <span>MORE</span>
                <img
                  class="more_btn"
                  src="../../assets/images/public/arrow1.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="box">
            <div class="image-container">
              <img
                src="../../assets/images1/about3.jpg"
                alt=""
                class="about-wap3__img"
              />
            </div>
            <div class="other-container">
              <div>
                <h2 class="title">{{ aboutPageLang.contentFour.area.title }}</h2>
                <p>
                  {{ aboutPageLang.contentFour.area.content }}
                </p>
              </div>
              <div class="dynamic_btn" @click="toyyly">
                <span>MORE</span>
                <img
                  class="more_btn"
                  src="../../assets/images/public/arrow1.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="box">
            <div class="image-container">
              <img
                src="../../assets/images1/about4.jpg"
                alt=""
                class="about-wap3__img"
              />
            </div>
            <div class="other-container">
              <div>
                <h2 class="title">{{ aboutPageLang.contentFour.service.title }}</h2>
                <p>
                  {{ aboutPageLang.contentFour.service.content }}
                </p>
              </div>
              <div class="dynamic_btn" @click="toService">
                <span>MORE</span>
                <img
                  class="more_btn"
                  src="../../assets/images/public/arrow1.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import About from "./aboutDetail.vue";
import History from "./history.vue";
import Network from "./Network.vue";
import Ability from "./ability.vue";
import Quality from "./Quality.vue";
import Development from "./Development.vue";
import Qualifications from "./Qualifications.vue";

export default {
  inject: ['reload'],
  components: {
    About,
    History,
    Network,
    Ability,
    Quality,
    Development,
    Qualifications
  },

  data() {
    return {
      activeName: "0",
      activeNameText: ""
      // mainShow: true,
      // footShow:false
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    aboutPageLang() {
      return this.currentLang.config.aboutPage
    },
    homePageLang() {
      return this.currentLang.config.homePage
    },
    navbarLang() {
      return this.currentLang.config.navbar
    }
  },

  mounted() {
    if (this.$route.query.index) {
      this.activeName = this.$route.query.index
      this.setNavActiveNameText(this.activeName)
    }
  },
  methods: {
    convertPxToRem(html) {
    const rootValue = 16; // 必须与 postcss-px2rem 的 rootValue 一致
    return html.replace(/(\d+)px/g, (match, px) => {
      return `${px / rootValue}rem`;
    });
  },
    setNavActiveNameText(active) {
      const { tabnav } = this.aboutPageLang
      switch(active) {
        case '1': this.activeNameText = tabnav.about;break;
        case '2': this.activeNameText = tabnav.history;break;
        case '3': this.activeNameText = tabnav.network;break;
        case '4': this.activeNameText = tabnav.ability;break;
        case '5': this.activeNameText = tabnav.quality;break;
        case '6': this.activeNameText = tabnav.development;break;
        case '7': this.activeNameText = tabnav.qualifications;break;
      }
    },

    handleClick(tab) {
      this.activeNameText = tab.label;
      this.$router.push({
        path: '/about',
        query: {
          index: this.activeName
        }
      })
      this.reload();
    },
    
    toAbout(){
      this.activeName = '1'
      this.activeNameText = this.currentLang.config.aboutPage.tabnav.about
    },
    toHistory(){
      this.activeName = '2'
      this.activeNameText = this.currentLang.config.aboutPage.tabnav.history
    },
    toyyly(){
      this.$router.push('/yyly')
    },
    toService(){
      this.$router.push('/customer_service')
    },

    // 源：改前
    /* toPath(){
      this.reload();
    } */
    // 改后
    toPath(){
      this.$router.push({
        path: '/about'
      })
      this.reload();
    }
  }
};
</script>

<style lang="scss" scoped>

.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}
.area_cation {
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}
.about-wap1 {
  padding-top: 90px;
  padding-bottom: 90px;

  .about-content {
    width: 1200px;
    margin: 0 auto;
    text-align: center;

    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      line-height: 1.8;
      text-align: justify;
      text-align-last: center;
      font-size: 18px;
      margin-top: 50px;
    }
  }
}

.about-wap2 {
  padding-top: 90px;
  padding-bottom: 90px;
  background: url(../../assets/images/about/about1.jpg) no-repeat;
  background-size: 100% 100%;

  .about-content {
    width: 1200px;
    margin: 0 auto 0;
    text-align: center;

    p {
      color: rgba(255, 255, 255, 0.7);
      font-size: var(--text-size-bit-larger);
      line-height: 1.8;
      text-align: justify;
      text-align-last: center;
      margin-top: 50px;
    }
  }
}

.about-wap3 {
  padding-top: 90px;
  padding-bottom: 90px;

  .about-content {
    width: 1200px;
    min-height: 540px;
    margin: 0 auto 0;
  }

  .box {
    display: flex;
    flex-direction: column;
    width: 380px;
    background: #f5f5f5;
  }

  .image-container {
    width: 100%;
    height: 280px;
    overflow: hidden;
  }

  /* 鼠标经过图片放大动效 */
  .image-container :hover {
    transition: all 0.5s;
    transform: scale(1.1);
  }

  .about-wap3__img {
    width: 100%;
    height: 280px;
  }

  .about-wap3__paragraph {
    width: 100%;
    text-align: justify;
    line-height: 1.8;
  }

  .other-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(100% - 60px);
    // height: calc(265px - 60px);
    height: auto;
    margin: 30px;
    text-align: left;

    .title {
      font-size: 22px;
      color: #333;
      font-weight: 500;
    }

    p {
      font-size: var(--text-size);
      line-height: 1.8;
      margin-top: 18px;
      color: #777;
    }

    .dynamic_btn {
      margin-top: 20px;
    }

    .more {
      margin-top: 30px;
    }
  }
}
.dynamic_btn {
  width: 140px;
  height: 45px;
  margin-top: 50px;
  background: #e8363e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;

  .more_btn {
    width: 40px;
    margin-left: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/about/about.vue